require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-how-can-the-world-bank-prevent-gbv-and-child-sea-in.json") })
        }
      }, "path---en-us-update-how-can-the-world-bank-prevent-gbv-and-child-sea-in");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-how-can-the-world-bank-prevent-gbv-and-child-sea-in!./.cache/json/en-us-update-how-can-the-world-bank-prevent-gbv-and-child-sea-in.json
// module id = 720
// module chunks = 231608221292675